import { useCallback } from 'react';

import type { UseShareActionsOptions } from '#src/app/shared/hooks/share';

export function useGetShareTrackingData(): UseShareActionsOptions['getTrackingData'] {
	return useCallback(
		(channel) => ({
			location: channel,
			view_context: 'news_show',
		}),
		[],
	);
}
